export const HeaderStyles = {
    headerContainer: "flex flex-col lg:flex-row justify-between items-start gap-4 sm:gap-2",
    headerLeftSection: "flex items-start",
    headerTitleSection: "flex flex-col items-start",
    pageTitle: "text-[24px] leading-[32px] font-bold",
    contentContainer: "bg-white rounded-lg shadow-iw-layout flex flex-col sm:flex-row justify-between items-start p-4 sm:p-6",
    credentialListContainer: "container mx-auto"
}